import type { RouteObject } from "react-router";
import { Dashboard } from "./Dashboard";
import { DASHBOARD_SEGMENT } from "./dashboard.paths";

export const dashboardRoute: RouteObject = {
  path: DASHBOARD_SEGMENT,
  element: <Dashboard />,
};
